import contratosRotas from './contratos/ContratosRotas'
import requisicoesRotas from './requisicoes/RequisicoesRotas'
import pagamentosRotas from './pagamentos/PagamentosRotas'
import apoiosRotas from './apoios/ApoiosRotas'
import servicosRotas from './servicos/ServicosRotas'

export default {
    path: 'gerentes',
    name: 'Gescon_Gerentes',
    component: {
        render(c) {
            return c('router-view')
        }
    },
    children: [contratosRotas, requisicoesRotas, pagamentosRotas, apoiosRotas, servicosRotas]
}
